import { render } from "./GolfAvailability.vue?vue&type=template&id=64498c5e"
import script from "./GolfAvailability.vue?vue&type=script&lang=js"
export * from "./GolfAvailability.vue?vue&type=script&lang=js"

import "./GolfAvailability.vue?vue&type=style&index=0&id=64498c5e&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__